export default __webpack_public_path__ + "locales/it/EmptyView.json?hash=e016d725625fce84455220e0cffc57ad";